import require from './require.js'

function requireFn(url, params, method = 'post') {
    return require({
        url,
        params,
        method
    })
}
export default requireFn